/* MUVA — PDP bundle widget. Progressive: does nothing if markup is absent. */
(function () {
  const money = (cents, fmt) => {
    const v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt && fmt.indexOf('{{') !== -1
      ? fmt.replace(/\{\{\s*amount[^}]*\}\}/, v)
      : '$' + v;
  };

  class BundleBuilder extends HTMLElement {
    /* More candidates than slots: keep a random `limit` of them, stable for the
       visitor's session, and drop the rest before anything else reads the DOM. */
    pickCandidates() {
      const limit = Number(this.dataset.limit || 0);
      const cand = Array.from(this.querySelectorAll('[data-bundle-candidate]'));
      if (!limit || cand.length <= limit) return;
      const key = 'muvaPair:' + (this.dataset.productId || location.pathname);
      let keepIdx = null;
      try {
        const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
        const have = cand.map((c) => c.dataset.bundleIndex);
        if (Array.isArray(saved) && saved.length === limit && saved.every((i) => have.includes(i))) keepIdx = saved;
      } catch (e) {}
      if (!keepIdx) {
        const pool = cand.map((c) => c.dataset.bundleIndex);
        for (let i = pool.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [pool[i], pool[j]] = [pool[j], pool[i]];
        }
        keepIdx = pool.slice(0, limit);
        try { sessionStorage.setItem(key, JSON.stringify(keepIdx)); } catch (e) {}
      }
      cand.forEach((c) => {
        const row = this.querySelector('[data-bundle-row="' + c.dataset.bundleIndex + '"]');
        if (keepIdx.includes(c.dataset.bundleIndex)) {
          c.hidden = false;
          if (row) row.hidden = false;
        } else {
          c.remove();
          if (row) row.remove();
        }
      });
    }

    connectedCallback() {
      this.pickCandidates();
      this.items = Array.from(this.querySelectorAll('[data-bundle-item]'));
      this.btn = this.querySelector('[data-bundle-add]');
      this.label = this.querySelector('[data-bundle-label]');
      this.err = this.querySelector('[data-bundle-error]');
      this.fmt = this.dataset.moneyFormat || '';
      this.addLabel = this.dataset.addLabel || 'Add bundle';
      if (!this.items.length || !this.btn) return;

      const rowOf = (card) => this.querySelector('[data-bundle-row="' + card.dataset.bundleIndex + '"]');

      this.items.forEach((card) => {
        const box = card.querySelector('[data-bundle-toggle]');
        const row = rowOf(card);
        if (box) box.addEventListener('change', () => {
          card.classList.toggle('is-on', box.checked);
          if (row) row.classList.toggle('is-off', !box.checked);
          this.refresh();
        });
        if (!row) return;
        row.querySelectorAll('[data-bundle-chip]').forEach((chip) => {
          chip.addEventListener('click', () => {
            if (chip.disabled) return;
            row.querySelectorAll('[data-bundle-chip]').forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
            const hidden = card.querySelector('[data-bundle-id]');
            if (hidden) hidden.value = chip.dataset.variantId;
            card.dataset.price = chip.dataset.price || card.dataset.price;
            if (chip.dataset.preorder) card.dataset.preorder = chip.dataset.preorder;
            const p = row.querySelector('[data-bundle-price]');
            if (p) p.textContent = money(Number(card.dataset.price), this.fmt);
            const n = row.querySelector('[data-bundle-selected]');
            if (n) n.textContent = chip.dataset.title || '';
            const img = card.querySelector('[data-bundle-img]') || card.querySelector('.pdp-bundle__media img');
            if (img && chip.dataset.img) { img.removeAttribute('srcset'); img.src = chip.dataset.img; }
            this.refresh();
          });
        });
      });

      this.mainCard = this.querySelector('[data-main-product]');
      if (this.mainCard) this.watchMainVariant();

      this.btn.addEventListener('click', () => this.add());
      this.refresh();
    }

    /* The theme does not broadcast variant changes, so read the product form's
       hidden id input — that is the source of truth for what Add to Cart sends. */
    mainInput() {
      return document.querySelector(
        'product-form input[name="id"], form[action*="/cart/add"] input[name="id"]'
      );
    }

    watchMainVariant() {
      let map = {};
      try { map = JSON.parse(this.dataset.mainVariants || '{}'); } catch (e) {}
      const sync = () => {
        const input = this.mainInput();
        if (!input || !input.value) return;
        const hidden = this.mainCard.querySelector('[data-bundle-id]');
        if (hidden && hidden.value === input.value) return;
        if (hidden) hidden.value = input.value;
        const v = map[input.value];
        if (v) {
          this.mainCard.dataset.price = v.p;
          if (v.o !== undefined) this.mainCard.dataset.preorder = v.o ? '1' : '0';
          const mrow = this.querySelector('[data-bundle-row="0"]') || this.mainCard;
          const p = mrow.querySelector('[data-bundle-price]');
          if (p) p.textContent = money(Number(v.p), this.fmt);
          const n = mrow.querySelector('[data-bundle-selected]');
          if (n) n.textContent = v.t;
        }
        this.refresh();
      };
      sync();
      document.addEventListener('change', sync, true);
      document.addEventListener('click', () => setTimeout(sync, 250), true);
      window.addEventListener('popstate', sync);
    }

    chosen() {
      return this.items
        .filter((c) => {
          const b = c.querySelector('[data-bundle-toggle]');
          return b && b.checked;
        })
        .map((c) => {
          const f = c.querySelector('[data-bundle-id]');
          return { id: f && f.value, price: Number(c.dataset.price || 0), preorder: c.dataset.preorder === '1' };
        })
        .filter((x) => x.id);
    }

    refresh() {
      const picked = this.chosen();
      const total = picked.reduce((s, x) => s + x.price, 0);
      this.btn.disabled = picked.length === 0;
      if (this.label) {
        this.label.textContent = picked.length
          ? `${this.addLabel} (${picked.length}) · ${money(total, this.fmt)}`
          : this.addLabel;
      }
    }

    showError(msg) {
      if (!this.err) return;
      this.err.textContent = msg;
      this.err.classList.add('is-on');
    }

    async add() {
      const picked = this.chosen();
      if (!picked.length) return;
      if (this.err) this.err.classList.remove('is-on');

      const drawer = document.querySelector('cart-drawer');
      let sections = [];
      try {
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          sections = drawer.getSectionsToRender().map((s) => s.id).filter(Boolean);
        }
      } catch (e) { sections = []; }

      const body = {
        items: picked.map((x) => {
          const item = { id: Number(x.id), quantity: 1 };
          // same line property the product form sends for pre-order variants
          if (x.preorder) item.properties = { 'Pre-order': 'Ships in 10–15 business days' };
          return item;
        }),
      };
      if (sections.length) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }

      this.btn.setAttribute('aria-busy', 'true');
      this.btn.disabled = true;
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(root.replace(/\/$/, '') + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const state = await res.json();
        if (!res.ok) throw new Error(state.description || state.message || 'Could not add to cart');

        if (drawer && state.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);           // this also opens the drawer
        } else {
          window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pdp-bundle' });
        }
      } catch (e) {
        this.showError(e.message || 'Something went wrong. Please try again.');
      } finally {
        this.btn.removeAttribute('aria-busy');
        this.refresh();
      }
    }
  }

  if (!customElements.get('bundle-builder')) {
    customElements.define('bundle-builder', BundleBuilder);
  }
})();
